import { Menu, Transition } from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/24/outline"

import { signOut, useSession } from "next-auth/react"
import { Fragment } from "react"

import navigation from "@/data/navigation.json"

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

export default function LinksNav() {
    const session = useSession()

    return (
        <>
            {navigation.map((item) => (
                <Menu as="div" key={item.name} className="relative ml-3 flex-col my-3">
                    {/* <a
                        key={item.name}
                        href={item.href}
                        // className={classNames(
                        //   item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                        //   'rounded-md px-3 py-2 text-lg font-medium'
                        // )}
                        className={classNames(
                            item.current ? ' text-red-800' : 'text-black-300  hover:text-red-800',
                            'py-2 text-lg font-medium'
                        )}
                        aria-current={item.current ? 'page' : undefined}
                    >
                        {item.name}
                    </a> */}
                    {/* <Menu.Button className="relative flex pt-3 ml-0 "> */}
                    <Menu.Button className={classNames(
                        item.current ? ' text-red-800' : 'text-black-300 hover:text-red-800',
                        'py-2 font-medium flex items-center gap-1 fs-200'
                    )}>
                        <span >
                            {item.name}
                        </span>
                        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5739 0.921902L7.04365 6.46741L1.51344 0.921901L12.5739 0.921902Z" fill="black" stroke="black" strokeWidth="0.7875" />
                        </svg>

                        {/* <ChevronDownIcon className="w-8 h-8" aria-hidden="true" /> */}
                        {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                          </svg> */}
                        {/* <ChevronDownIcon className={classNames(
                            item.current ? ' text-red-800' : 'text-black-300  hover:text-red-800',
                            'w-6 h-6 pl-1'
                        )} aria-hidden="true" /> */}

                    </Menu.Button>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items className="absolute right-0 left-0 z-10 mt-0 w-56 origin-top-right rounded-md bg-white py-1  ring-1 ring-black ring-opacity-5 focus:outline-none">
                            {item.subitems.map((subitem: any) =>
                                <Menu.Item key={subitem.name}>
                                    {({ active }) => (
                                        <a
                                            href={subitem.href}
                                            className={classNames(active ? 'bg-gray-100 text-decoration-none' : '', 'block px-4 py-2 text-2xl text-gray-700 text-decoration-none')}
                                        >
                                            {subitem.name}
                                        </a>
                                    )}
                                </Menu.Item>
                            )}
                        </Menu.Items>
                    </Transition>
                </Menu >
            ))
            }
        </>
    )
}